/* Native disclosure navigation; commerce is handled once by rb-commerce.js. */
(function () {
  'use strict';
  if (window.__rbShellV1) return;
  window.__rbShellV1 = true;
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-rb-mobile-menu][open]').forEach(function (menu) {
      menu.open = false;
      menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-rb-mobile-menu][open]').forEach(function (menu) {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
  });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-rb-mobile-menu][open]').forEach(function (menu) {menu.open = false;});
  });
})();
